import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import moment from 'moment';

@Component({
    selector: 'start-end-date-picker',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class StartEndDatePicker implements OnInit {
  @Input() startDate: string;
  @Input() endDate: string;

  @Input() FormGroup: FormGroup;

  public form: FormGroup;

  public date: Date;

  public startDateFixed: boolean;
  public endDateFixed: boolean;

  public ngOnInit() {
    const startDate = this.startDate
      ? moment(new Date(this.startDate).toDateString()).startOf('day').toDate()
      : null;
    const endDate = this.endDate
      ? moment(new Date(this.endDate).toDateString()).startOf('day').toDate()
      : null;

    this.form = new FormBuilder().group({
      startDate: [startDate],
      endDate: [endDate],
    });

    this.startDateFixed = !!this.startDate;
    this.endDateFixed = !!this.endDate;
  }

  public setStartDateFixed(fixed: boolean) {
    if (fixed) {
      const startDate = this.startDate
        ? moment(this.startDate).startOf('day')
        : moment().startOf('day');

      this.form.controls['startDate'].patchValue(startDate.toDate());
      this.FormGroup.controls['start_date'].patchValue(
        startDate.format('YYYY-MM-DD')
      );

      this.startDateFixed = fixed;
    } else {
      this.startDateFixed = fixed;

      this.form.controls['startDate'].patchValue(null);
      this.FormGroup.controls['start_date'].patchValue(null);
    }

    this.setErrors();
  }

  public setEndDateFixed(fixed: boolean) {
    if (fixed) {
      const endDate = this.endDate
        ? moment(this.endDate).startOf('day')
        : moment().startOf('day');

      this.form.controls['endDate'].patchValue(endDate.toDate());
      this.FormGroup.controls['end_date'].patchValue(
        endDate.format('YYYY-MM-DD')
      );

      this.endDateFixed = fixed;
    } else {
      this.endDateFixed = fixed;

      this.form.controls['endDate'].patchValue(null);
      this.FormGroup.controls['end_date'].patchValue(null);
    }

    this.setErrors();
  }

  public onStartDateChange() {
    this.FormGroup.controls['start_date'].patchValue(
      moment(this.form.controls['startDate'].value).format('YYYY-MM-DD')
    );

    this.setErrors();
  }

  public onEndDateChange() {
    this.FormGroup.controls['end_date'].patchValue(
      moment(this.form.controls['endDate'].value).format('YYYY-MM-DD')
    );

    this.setErrors();
  }

  private setErrors() {
    setTimeout(() => {
      const startDateErrors = this.form.get('startDate').errors;
      const endDateErrors = this.form.get('endDate').errors;

      this.FormGroup.controls['start_date'].setErrors(startDateErrors);
      this.FormGroup.controls['end_date'].setErrors(endDateErrors);
    });
  }
}
